import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const assessmentsRoutes = [
  {
    path: '/assessments',
    name: Routes.Assessments,
    component: () => import('@/pages/contexts/portal/assessments/Index.vue'),
    meta: {
      pageTitle: 'Manage Assessments',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_ASSESSMENTS,
    },
    children: [
      {
        path: 'create',
        name: Routes.AssessmentCreate,
        component: () => import('@/pages/contexts/portal/assessments/Create.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_ASSESSMENTS,
        },
      },
      {
        path: 'edit/:assessmentId',
        name: Routes.AssessmentEdit,
        component: () => import('@/pages/contexts/portal/assessments/Edit.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_ASSESSMENTS,
        },
      },
    ],
  },
  {
    path: '/assessments/staff',
    name: Routes.AssessmentStaffList,
    component: () => import('@/pages/contexts/portal/assessments/staff/Index.vue'),
    meta: {
      pageTitle: 'Staff Assessment Logs',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_ASSESSMENTS,
    },
  },
  {
    path: '/assessments/staff/:staffId',
    name: Routes.AssessmentStaffLogs,
    component: () => import('@/pages/contexts/portal/assessments/staff/_staffId/Index.vue'),
    meta: {
      pageTitle: 'Assessment Logs',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_ASSESSMENTS,
    },
    children: [
      {
        path: 'create',
        name: Routes.AssessmentStaffLogsCreate,
        component: () => import('@/pages/contexts/portal/assessments/staff/_staffId/Create.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.VIEW_ASSESSMENTS,
        },
      },
    ],
  },
]
